/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconTag/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconTag({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconTag",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#323232",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconTag.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z283Cd5': alignSelf,'--mt-2-Z283Cd5': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z283Cd5': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z283Cd5': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z283Cd5': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z283Cd5': opacity,'--w-10-Z283Cd5': typeof width === 'number' ? `${width}px` : width,'--h-11-Z283Cd5': typeof height === 'number' ? `${height}px` : height,'--f-12-Z283Cd5': fill,'--a-7-Z283Cd5': isAnimated ? animation : "none",'--sd-8-Z283Cd5': isAnimated ? strokeDashoffset : 0,'--sd-9-Z283Cd5': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconTag.SvgPath"
  data-view-path={viewPath}
 d="M20 10V8h-4V4h-2v4h-4V4H8v4H4v2h4v4H4v2h4v4h2v-4h4v4h2v-4h4v-2h-4v-4h4zm-6 4h-4v-4h4v4z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}